import { render, staticRenderFns } from "./UserAvatarForm.vue?vue&type=template&id=132cb79c&scoped=true&"
import script from "./UserAvatarForm.vue?vue&type=script&lang=js&"
export * from "./UserAvatarForm.vue?vue&type=script&lang=js&"
import style0 from "./UserAvatarForm.vue?vue&type=style&index=0&id=132cb79c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132cb79c",
  null
  
)

export default component.exports